"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionComponent = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _ButtonStyled = require("../../ButtonStyled");
var _QuestionComponent = require("./QuestionComponent.styled");
var _reactstrap = require("reactstrap");
var _constants = require("../../../constants");
var _hooks = require("../../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var QuestionComponent = exports.QuestionComponent = function QuestionComponent(_ref) {
  var _id = _ref._id,
    question = _ref.question,
    answer = _ref.answer,
    likesCount = _ref.likesCount,
    status = _ref.status,
    isLiked = _ref.isLiked,
    senderName = _ref.senderName,
    onAnswerSubmit = _ref.onAnswerSubmit,
    onArchiveClick = _ref.onArchiveClick,
    onRestoreClick = _ref.onRestoreClick,
    onLikeClick = _ref.onLikeClick,
    avatarColor = _ref.avatarColor,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === void 0 ? false : _ref$isAdmin;
  var _useFocus = (0, _hooks.useFocus)(),
    _useFocus2 = (0, _slicedToArray2["default"])(_useFocus, 2),
    answerInputRef = _useFocus2[0],
    setAnswerInputFocus = _useFocus2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showButtons = _useState2[0],
    setShowButtons = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isAnswering = _useState4[0],
    setIsAnswering = _useState4[1];
  var _useState5 = (0, _react.useState)(answer),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    answerInput = _useState6[0],
    setAnswerInput = _useState6[1];
  var isAnswered = status === _constants.QUESTIONS_ANSWERED_TYPE;
  var isArchived = status === _constants.QUESTIONS_ARCHIVED_TYPE;
  var showQandA = isAnswered || isArchived;
  var initials = senderName.split(' ');
  initials = "".concat(initials[0][0]).concat(initials[1] ? initials[1][0] : '');
  (0, _react.useEffect)(function () {
    if (isAnswering) {
      setAnswerInputFocus();
    }
  }, [isAnswering]);
  var onAnswerChange = function onAnswerChange(e) {
    setAnswerInput(e.target.value);
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    onAnswerSubmit(answerInput, _id);
  };
  var onArchiveButtonClick = function onArchiveButtonClick() {
    if (isArchived) {
      onRestoreClick(_id);
    } else {
      onArchiveClick(_id);
    }
  };
  var onLikeClickFn = function onLikeClickFn(id) {
    if (!isAdmin) {
      onLikeClick(id);
    }
  };
  return _react["default"].createElement(_QuestionComponent.StyledContainer, {
    className: "p-0 pt-2 pb-2 text-white",
    onMouseOver: isAnswering ? null : function () {
      return setShowButtons(true);
    },
    onMouseLeave: isAnswering ? null : function () {
      return setShowButtons(false);
    },
    role: "container"
  }, _react["default"].createElement(_reactstrap.Row, null, _react["default"].createElement(_reactstrap.Col, {
    className: "d-flex justify-content-between mb-2 p-0 pt-1"
  }, _react["default"].createElement("section", {
    className: "d-flex"
  }, _react["default"].createElement("section", {
    className: "me-1"
  }, _react["default"].createElement(_QuestionComponent.Avatar, {
    $bgColor: avatarColor
  }, _react["default"].createElement("label", null, initials))), _react["default"].createElement("section", null, _react["default"].createElement("small", null, senderName))), _react["default"].createElement("section", null, _react["default"].createElement(_QuestionComponent.LikeIcon, {
    normalCursor: isAdmin,
    icon: isLiked ? _freeSolidSvgIcons.faThumbsUp : _freeRegularSvgIcons.faThumbsUp,
    onClick: function onClick() {
      return onLikeClickFn(_id);
    },
    color: isLiked ? '#F66A0A' : '#8D91AF',
    "data-testid": "like"
  }), _react["default"].createElement(_QuestionComponent.LikeCount, {
    $isLiked: isLiked,
    className: "m-1"
  }, likesCount)))), _react["default"].createElement(_reactstrap.Row, null, _react["default"].createElement(_reactstrap.Col, {
    className: "p-0"
  }, _react["default"].createElement("span", {
    className: "me-1 d-".concat(showQandA ? 'inline-block' : 'none', " p-0")
  }, "Q:", ' '), _react["default"].createElement(_QuestionComponent.BoldText, {
    className: "pb-1"
  }, question))), _react["default"].createElement(_reactstrap.Row, {
    className: "d-".concat(showQandA ? 'block' : 'none', " p-0")
  }, _react["default"].createElement(_reactstrap.Col, {
    className: "p-0"
  }, _react["default"].createElement("span", null, "A: "), _react["default"].createElement(_QuestionComponent.BoldText, {
    className: "pb-1"
  }, answer))), isAdmin && _react["default"].createElement(_reactstrap.Collapse, {
    role: "buttons-wrapper",
    isOpen: showButtons
  }, _react["default"].createElement(_reactstrap.Row, {
    className: "d-".concat(isAnswering ? 'none' : 'block')
  }, _react["default"].createElement(_reactstrap.Col, {
    className: "d-flex justify-content-center"
  }, _react["default"].createElement(_ButtonStyled.ButtonStyled, {
    faIcon: isAnswered ? _freeSolidSvgIcons.faEdit : _freeSolidSvgIcons.faComment,
    onClick: function onClick() {
      return setIsAnswering(!isAnswering);
    },
    showButton: !isArchived
  }, isAnswered ? 'Edit' : 'Answer'), _react["default"].createElement(_ButtonStyled.ButtonStyled, {
    faIcon: isArchived ? _freeSolidSvgIcons.faUndo : _freeSolidSvgIcons.faArchive,
    onClick: onArchiveButtonClick
  }, isArchived ? 'Restore' : 'Archive')))), isAdmin && _react["default"].createElement(_reactstrap.Row, {
    className: "me-0 ms-0 d-".concat(isAnswering ? 'block' : 'none'),
    role: "form-wrapper"
  }, _react["default"].createElement(_reactstrap.Form, {
    onSubmit: onAnswerSubmit
  }, _react["default"].createElement(_reactstrap.Label, {
    htmlFor: "answer-".concat(initials)
  }, "Answer:"), _react["default"].createElement(_reactstrap.Input, {
    type: "textarea",
    value: answerInput,
    onChange: onAnswerChange,
    "data-testid": "answer",
    id: "answer-".concat(initials),
    innerRef: answerInputRef
  }), _react["default"].createElement("section", {
    className: "d-flex justify-content-end"
  }, _react["default"].createElement(_ButtonStyled.ButtonStyled, {
    onClick: handleSubmit,
    color: "primary"
  }, "Submit"), _react["default"].createElement(_ButtonStyled.ButtonStyled, {
    onClick: function onClick() {
      return setIsAnswering(false);
    }
  }, "Cancel")))));
};
QuestionComponent.propTypes = {
  likesCount: _propTypes["default"].number,
  question: _propTypes["default"].string.isRequired,
  answer: _propTypes["default"].string,
  status: _propTypes["default"].oneOf([_constants.QUESTIONS_OPEN_TYPE, _constants.QUESTIONS_ANSWERED_TYPE, _constants.QUESTIONS_ARCHIVED_TYPE]),
  senderName: _propTypes["default"].string,
  onAnswerClick: _propTypes["default"].func,
  onArchiveClick: _propTypes["default"].func,
  onLikeClick: _propTypes["default"].func,
  avatarColor: _propTypes["default"].string,
  _id: _propTypes["default"].string
};
QuestionComponent.defaultProps = {
  likesCount: 0,
  answer: '',
  status: _constants.QUESTIONS_OPEN_TYPE,
  isLiked: false
};